(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["free-gift-item"] && !Shopify.designMode) return;
  try {
    function pqGiftsArmB() { return document.documentElement.classList.contains('pq-gifts-b'); }

function runGiftGrouping() {
  var cards = Array.prototype.slice.call(document.querySelectorAll('.free-gift-card'));

  function getAncestors(node) {
    var arr = [];
    while (node) { arr.push(node); node = node.parentElement; }
    return arr;
  }

  function processGroup(groupCards) {
    if (!groupCards.length) return;
    var common = getAncestors(groupCards[0]);
    for (var i = 1; i < groupCards.length; i++) {
      var thisAncestors = getAncestors(groupCards[i]);
      common = common.filter(function (n) { return thisAncestors.indexOf(n) !== -1; });
    }
    var container = common[0];
    if (!container) return;
    if (container.classList && container.classList.contains('free-gift-grid')) return;

    var firstBranch = groupCards[0];
    while (firstBranch.parentElement !== container) { firstBranch = firstBranch.parentElement; }

    var grid = document.createElement('div');
    grid.className = 'free-gift-grid';
    // arm A never shows the Free Shipping card (the live row has four gifts); arm B hides this row and draws its own box
    var visible = groupCards.filter(function (c) { return c.getAttribute('data-gift-kind') !== 'shipping'; }).length || groupCards.length;
    grid.style.setProperty('--gift-count', visible);
    container.insertBefore(grid, firstBranch);

    groupCards.forEach(function (card) {
      var originalParent = card.parentElement;
      grid.appendChild(card);
      removeEmptyAncestors(originalParent, container);
    });

    function removeEmptyAncestors(node, stopAt) {
      while (node && node !== stopAt && node.parentElement) {
        var parent = node.parentElement;
        var isEmpty = node.children.length === 0 && node.textContent.trim() === '';
        if (isEmpty) { node.remove(); node = parent; } else { break; }
      }
    }

    var heading = container.querySelector('.free-gift-heading');
    if (heading) { container.insertBefore(heading, grid); }
  }

  var groups = {};
  var groupOrder = [];
  cards.forEach(function (card) {
    var sectionEl = card.closest('.shopify-section');
    var key = sectionEl ? sectionEl.id : 'no-section-fallback';
    if (!groups[key]) { groups[key] = []; groupOrder.push(key); }
    groups[key].push(card);
  });
  groupOrder.forEach(function (key) { processGroup(groups[key]); });

  document.querySelectorAll('[id*="free_gift_item"]').forEach(function (el) {
    if (el.children.length === 0 && el.textContent.trim() === '') { el.remove(); }
  });

  pqGiftsApply();
}

/* 16 Sep 2026, arm B of gifts-unlock-v1: the GIFTS UNLOCKED box after the bundle cards, locks by the selected tier,
   the gift list inside the selected card. Arm A: nothing beyond the row above. */
var PQ_GU_LOCK = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#47184D" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
var PQ_GU_CHECK = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>';
function pqGuEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
function pqGuData(card) {
  var img = card.querySelector('.free-gift-card__image img');
  var svg = card.querySelector('.free-gift-card__image svg');
  var titleEl = card.querySelector('.free-gift-card__title');
  var valueEl = card.querySelector('.price-badge');
  var pillEl = card.querySelector('.free-edd');
  var title = titleEl ? titleEl.textContent.trim() : '';
  return {
    need: parseInt(card.getAttribute('data-unlock-qty'), 10) || 1,
    kind: card.getAttribute('data-gift-kind') || 'product',
    short: (card.getAttribute('data-short') || '').trim() || title,
    title: title,
    value: valueEl ? valueEl.textContent.trim() : '',
    note: (card.getAttribute('data-note') || '').trim() || (pillEl ? pillEl.textContent.trim() : ''),
    tileValue: (card.getAttribute('data-value-text') || '').trim(),
    lockText: card.getAttribute('data-lock-text') || 'Locked',
    imgHtml: img ? '<img src="' + pqGuEsc(img.getAttribute('src')) + '" alt="" loading="lazy" decoding="async">' : (svg ? svg.outerHTML : '')
  };
}
function pqGuName(s) { var m = /^(FREE)\s+(.+)$/i.exec(s || ''); if (m) { return '<b>' + pqGuEsc(m[1]) + '</b>' + pqGuEsc(m[2]); } var parts = String(s || '').trim().split(/\s+/); if (parts.length >= 2) { return '<b>' + pqGuEsc(parts[0]) + '</b>' + pqGuEsc(parts.slice(1).join(' ')); } return pqGuEsc(s); } /* two lines always: the first word above the rest, so every item stays narrow */
function pqGuBuildBox(cards) {
  var box = document.createElement('div');
  box.className = 'pq-gu';
  var html = '<div class="pq-gu__label">' + pqGuEsc(cards[0].getAttribute('data-box-label') || 'GIFTS UNLOCKED') + '</div><div class="pq-gu__row">';
  cards.forEach(function (card) {
    var d = pqGuData(card);
    var under = d.value ? '<div class="pq-gu__val">' + pqGuEsc(d.value) + '</div>' : (d.tileValue ? '<div class="pq-gu__val pq-gu__val--plain">' + pqGuEsc(d.tileValue) + '</div>' : (d.note ? '<div class="pq-gu__val pq-gu__val--plain">' + pqGuEsc(d.note) + '</div>' : ''));
    html += '<div class="pq-gu__item" data-need="' + d.need + '"><div class="pq-gu__img">' + d.imgHtml + '</div>' + under +
      '<div class="pq-gu__name">' + pqGuName(d.short) + '</div><div class="pq-gu__lock">' + PQ_GU_LOCK + '<span>' + pqGuEsc(d.lockText) + '</span></div></div>';
  });
  box.innerHTML = html + '</div>';
  return box;
}
function pqGuBuildCardList(datas) {
  var el = document.createElement('div');
  el.className = 'pq-gu-card';
  var html = '<div class="pq-gu-card__divider"><span>Plus free gifts</span></div>';
  datas.forEach(function (d) {
    var t = d.title;
    if (d.kind !== 'shipping' && d.value && !/^free\b/i.test(t)) { t = 'FREE ' + t; }
    html += '<div class="pq-gu-card__item"><span class="pq-gu-card__check">' + PQ_GU_CHECK + '</span><div><div class="pq-gu-card__t">' + pqGuEsc(t) +
      (d.value ? ' <span>(' + pqGuEsc(d.value) + ' Value)</span>' : '') + '</div>' + (d.note ? '<div class="pq-gu-card__n">' + pqGuEsc(d.note) + '</div>' : '') + '</div></div>';
  });
  el.innerHTML = html;
  return el;
}
function pqGiftsApply() {
  var armB = pqGiftsArmB();
  var sections = document.querySelectorAll('.shopify-section');
  for (var s = 0; s < sections.length; s++) {
    var section = sections[s];
    var cards = Array.prototype.slice.call(section.querySelectorAll('.free-gift-card'));
    if (!cards.length) continue;
    var options = Array.prototype.slice.call(section.querySelectorAll('.bundle-option'));
    var selected = section.querySelector('.bundle-option.is-selected') || options[0];
    var qty = selected ? (parseInt(selected.getAttribute('data-qty'), 10) || 1) : 99;
    var box = section.querySelector('.pq-gu');
    if (!armB) {
      if (box) { box.parentNode.removeChild(box); }
      Array.prototype.forEach.call(section.querySelectorAll('.pq-gu-card'), function (el) { el.parentNode.removeChild(el); });
      continue;
    }
    if (!box) {
      box = pqGuBuildBox(cards);
      var sel = section.querySelector('.bundle-selector-block');
      var anchor = sel ? (sel.closest('.shopify-block') || sel) : null;
      if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(box, anchor.nextSibling); }
      else { var grid = section.querySelector('.free-gift-grid') || cards[0]; grid.parentNode.insertBefore(box, grid); }
    }
    Array.prototype.forEach.call(box.querySelectorAll('.pq-gu__item'), function (it) {
      it.classList.toggle('is-locked', qty < (parseInt(it.getAttribute('data-need'), 10) || 1));
    });
    options.forEach(function (option) {
      var old = option.querySelector('.pq-gu-card');
      if (old) { old.parentNode.removeChild(old); }
      var save = option.querySelector('.bundle-option__save');
      if (save && /\+\s*FREE shipping/i.test(save.textContent)) { save.textContent = save.textContent.replace(/\s*\+\s*FREE shipping/i, ''); }
      if (option !== selected) { return; }
      var q = parseInt(option.getAttribute('data-qty'), 10) || 1;
      if (q < 2) { return; } // Andrei 16 Sep: nothing under the Buy One card; the box alone shows what it unlocks
      var datas = cards.map(pqGuData).filter(function (d) { return q >= d.need; });
      if (datas.length) { option.appendChild(pqGuBuildCardList(datas)); }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runGiftGrouping);
} else {
  runGiftGrouping();
}
document.addEventListener('bundle:selected', function () { setTimeout(pqGiftsApply, 0); });
document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.bundle-option')) { setTimeout(pqGiftsApply, 0); } }, true);

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () { setTimeout(runGiftGrouping, 0); });
  document.addEventListener('shopify:block:select', function () { setTimeout(pqGiftsApply, 0); });
}
  } catch(e) { console.error(e); }
})();

})();
